import React from "react";

const LoadingSpinnerComponent = () => (
  <div className="sid-spinner" data-testId="sid-spinner">
    <div className="sid-spinner__frame" />
    <div className="sid-spinner__frame" />
    <div className="sid-spinner__frame" />
    <div className="sid-spinner__frame" />
  </div>
);

export { LoadingSpinnerComponent };
